import type * as lazyIndex from "./lazyIndex";
import cancelDelaySend from "./actions/cancelDelaySend";
import { LazyModule, registerLazyOrchestrator } from "owa-bundling";

export { default as removeMailItemWithData } from "./actions/removeMailItemWithData";
export { getStore as getDelayedItemStore } from "./store/store";
export { default as cancelDelaySend, afterCancelDelaySend } from "./actions/cancelDelaySend";
export type { CancelDelaySendActionMessage } from "./actions/cancelDelaySend";
export type { CancelDelaySendSource } from "./store/schema/CancelDelaySendSource";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "DelaySendStore" */ "./lazyIndex"), { name: "DelaySendStore" });

registerLazyOrchestrator(cancelDelaySend, lazyModule, m => m.cancelDelaySendOrchestrator);
